import React, { useCallback, useEffect, useState } from "react";

import Navbar from "./clientHom/Navbar";
import Footer from "./uniComponents/AndUsFooter";

import FleetCorePageHero from "./fleetCore/FleetCorePageHero";
import FleetCoreProductNavigation from "./fleetCore/FleetCoreProductNavigation";
import FleetCoreProductFilmOverview from "./fleetCore/FleetCoreProductFilmOverview";
import FleetCoreFuelAccountabilityProblem from "./fleetCore/FleetCoreFuelAccountabilityProblem";
import FleetCoreAccountabilityLoop from "./fleetCore/FleetCoreAccountabilityLoop";
import FleetCoreVerifiedDriverOnboarding from "./fleetCore/FleetCoreVerifiedDriverOnboarding";
import FleetCoreVehicleRegistrationBaseline from "./fleetCore/FleetCoreVehicleRegistrationBaseline";
import FleetCoreDailyCheckInCheckOut from "./fleetCore/FleetCoreDailyCheckInCheckOut";
import FleetCoreFuelTransactionEvidence from "./fleetCore/FleetCoreFuelTransactionEvidence";
import FleetCoreFuelIntelligenceAnomalyDetection from "./fleetCore/FleetCoreFuelIntelligenceAnomalyDetection";
import FleetCoreVehicleConditionIntelligence from "./fleetCore/FleetCoreVehicleConditionIntelligence";
import FleetCoreManagementControlCentre from "./fleetCore/FleetCoreManagementControlCentre";
import FleetCoreRealFleetOperations from "./fleetCore/FleetCoreRealFleetOperations";
import FleetCoreImplementationResponsibleIntelligence from "./fleetCore/FleetCoreImplementationResponsibleIntelligence";
import FleetCoreAfricanFieldInterface from "./fleetCore/FleetCoreAfricanFieldInterface";
import FleetCoreDriverWhatsAppInterface from "./fleetCore/FleetCoreDriverWhatsAppInterface";
import BrochureRequestModal from "./clientHom/BrochureRequestModal";

import "./FleetCorePage.css";

export default function FleetCorePage() {
  const [brochureModalOpen, setBrochureModalOpen] = useState(false);
  const closeBrochureModal = useCallback(() => setBrochureModalOpen(false), []);
  const openBrochureModal = useCallback(() => setBrochureModalOpen(true), []);
  useEffect(() => {
    const previousTitle = document.title;

    document.title = "FleetCore | AndUs";
    window.scrollTo(0, 0);

    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className="fleet-core-public-page">
      <Navbar />

      <main className="fleet-core-public-page__main">
        <FleetCorePageHero onBrochureClick={openBrochureModal} />

        <FleetCoreProductNavigation />

        <FleetCoreProductFilmOverview />
        <FleetCoreFuelAccountabilityProblem />
        <FleetCoreAccountabilityLoop />
        <FleetCoreAfricanFieldInterface />
        <FleetCoreDriverWhatsAppInterface />
        <FleetCoreVerifiedDriverOnboarding />
        <FleetCoreVehicleRegistrationBaseline />
        <FleetCoreDailyCheckInCheckOut />
        <FleetCoreFuelTransactionEvidence />
        <FleetCoreFuelIntelligenceAnomalyDetection />
        <FleetCoreVehicleConditionIntelligence />
        <FleetCoreManagementControlCentre />
        <FleetCoreRealFleetOperations />
        <FleetCoreImplementationResponsibleIntelligence
          onBrochureClick={openBrochureModal}
        />

        <div
          id="fleet-core-public-page-content"
          className="fleet-core-public-page__development-anchor"
          aria-hidden="true"
        />
      </main>

      <Footer />
      <BrochureRequestModal
        open={brochureModalOpen}
        onClose={closeBrochureModal}
        productName="FleetCore"
        brochures={[
          {
            file: "AndUs_FleetCore_Product_Brochure_2026.pdf",
            title: "FleetCore Product Brochure 2026",
          },
        ]}
      />
    </div>
  );
}
